module.exports = __webpack_public_path__ + "assets/icon-installation-deselected.0ef4eb0a.svg";